<template>
  <template v-if="isAdVisible && adConfigUnwrapped">
    <GoogleAdPlaceholder
      :ad-id="adConfigUnwrapped.adId"
      :page="adConfigUnwrapped.pageType"
      :device="adConfigUnwrapped.deviceType"
      :brand="adConfigUnwrapped.brandName"
      :is-u-s-a-region="true"
      :is-wedding-registry="adConfigUnwrapped.isRegistry"
      :custom-style-class="adConfigUnwrapped.customStyleClass"
      :env-brand="adConfigUnwrapped.envBrand"
    />
  </template>
  <template v-if="shouldShowSponsored">
    <SponsoredItems
      :site-mon-config="sponsoredItems.siteMonConfig"
      :is-monetization-enabled="sponsoredItems.isMonetizationEnabled"
      :enable-impression-tags-for-s-m-products="sponsoredItems.enableImpressionTagsForSMProducts"
      :enable-click-tags-for-s-m-products="sponsoredItems.enableClickTagsForSMProducts"
      :carousel-open-in-new-tab-enabled="sponsoredItems.carouselOpenInNewTabEnabled"
      :is-badge-sale-red="sponsoredItems.isBadgeSaleRed"
      :is-mcom="isMcom"
      :selected-upc="unref(selectedUpc)"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, unref } from 'vue';
import SponsoredItems from '@nuxt-common/site-monetization/app/components/SponsoredItems';
import GoogleAdPlaceholder from '@nuxt-common/site-monetization/app/components/GoogleAdPlaceholder';

import { useSiteMonetization } from '~/composables/monetization/useSiteMonetization';
import { useBrand } from '~/composables/useBrand';

const props = defineProps({
  placement: {
    type: String,
    required: true,
    validator: (val: string) => ['top', 'inline', 'bottom'].includes(val),
  },
});

const { isMcom } = useBrand();
const { placements, showSponsoredItems, sponsoredItems, selectedUpc } = useSiteMonetization();

const adConfig = computed(() => placements[props.placement]);

const adConfigUnwrapped = computed(() => {
  const config = adConfig.value;
  if (!config) return null;
  return {
    adId: config.adId,
    pageType: config.pageType,
    deviceType: unref(config.deviceType),
    brandName: unref(config.brandName),
    isUSA: config.isUSA,
    isRegistry: config.isRegistry,
    envBrand: config.envBrand,
    customStyleClass: unref(config.customStyleClass),
    renderCondition: unref(config.renderCondition),
  };
});

const isAdVisible = computed(() => !!adConfigUnwrapped.value?.renderCondition);

const shouldShowSponsored = computed(() => {
  const config = adConfig.value;
  return !!(config?.canShowSponsored && unref(showSponsoredItems));
});
</script>
